import { useEffect, useState } from "react";

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section
      id="header"
      className="relative w-full min-h-screen flex items-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/368ed0a8c15943d284108ee7f6427639.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-10 flex items-center justify-between gap-16 py-32">
        {/* Left — Text */}
        <div
          className={`flex-1 max-w-[560px] transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <span className="inline-block px-4 py-1.5 rounded-full border border-emerald-500/50 text-emerald-400 text-[12px] uppercase tracking-widest font-medium mb-8">
            iOS Development Experts
          </span>

          <h1 className="text-[58px] font-bold text-white leading-[1.12] mb-6">
            Modern Apps for
            <br />
            a Safer, Faster
            <br />
            <span className="text-emerald-400">iPhone</span>
          </h1>

          <p className="text-[18px] text-white/70 leading-[1.75] max-w-[480px]">
            KESTEN d. o. o. is a team of experts crafting premium iOS applications. Our products — VPN and Cleaner — are built to protect your privacy and keep your device performing at its best.
          </p>

          <div className="mt-12 flex items-center gap-8">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-emerald-500/20 text-emerald-400">
                <i className="ri-shield-check-line text-xl" />
              </div>
              <span className="text-white/80 text-[14px] font-medium">Security First</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-emerald-500/20 text-emerald-400">
                <i className="ri-speed-up-line text-xl" />
              </div>
              <span className="text-white/80 text-[14px] font-medium">Peak Performance</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-emerald-500/20 text-emerald-400">
                <i className="ri-apple-line text-xl" />
              </div>
              <span className="text-white/80 text-[14px] font-medium">iOS Native</span>
            </div>
          </div>
        </div>

        {/* Right — App Visual */}
        <div
          className={`flex-shrink-0 transition-all duration-700 delay-200 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <div className="relative w-[440px] h-[560px]">
            <div className="absolute inset-0 rounded-[32px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Two%20iPhones%20side%20by%20side%20showing%20premium%20iOS%20mobile%20applications%2C%20one%20displaying%20a%20VPN%20shield%20security%20app%20with%20dark%20elegant%20interface%20and%20glowing%20green%20shield%2C%20another%20showing%20a%20clean%20storage%20optimizer%20app%20with%20white%20minimal%20UI%20and%20circular%20progress%20charts%2C%20professional%20product%20photography%20floating%20on%20dark%20subtle%20gradient%20background%2C%20studio%20lighting%2C%20ultra%20sharp%20render%2C%20premium%20quality&width=440&height=560&seq=hero-phones1&orientation=portrait"
                alt="KESTEN iOS apps"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* floating accent */}
            <div className="absolute -top-4 -right-4 w-24 h-24 rounded-full bg-emerald-500/20 blur-2xl" />
            <div className="absolute -bottom-4 -left-4 w-32 h-32 rounded-full bg-emerald-500/10 blur-3xl" />
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40">
        <span className="text-[11px] uppercase tracking-widest">Scroll</span>
        <i className="ri-arrow-down-line text-lg animate-bounce" />
      </div>
    </section>
  );
}
